<template>
  <div class="box">
    <img src="../../assets/share.png" alt="">
    <div class="box-lists">
      <div class="list">
        <img src="../../assets/share-zone.png" alt="">
        <div>QQ空间</div>
      </div>
      <div class="list">
        <img src="../../assets/share-weibo.png" alt="">
        <div>微博</div>
      </div>
      <div class="list">
        <img src="../../assets/share-qq.png" alt="">
        <div>QQ</div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  components: {

  },
  data () {
    return {

    }
  },
  created () {

  },
  methods: {

  }
}
</script>
<style scoped>
.box{
    display:flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top:60px;
    right:-24px;
    z-index:100;
  }
  .box img{
    width:433px;
    height:198px;
  }
  .box-lists{
    width:70%;
    margin:0 auto;
    display:flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    margin-top: 7px;
  }
  .list{
    text-align: center;
    font-size:14px;
    font-family:Source Han Sans CN;
    font-weight:300;
    color:rgba(0,0,0,1);
    cursor:pointer;
  }
  .list  img{
    width:72px;
    height:72px;
  }
</style>



// WEBPACK FOOTER //
// src/components/share/share.vue